export default {"src":"/_next/static/media/Purple Booth Mark.555a1209.svg","height":620,"width":820};